module.exports = __webpack_public_path__ + "img/pic-grid.b40d4858.png";